import { DistancesBetweenPointsType } from '@graphql/generated';
import type { VacationRentalAreaDataBackend, VacationRentalTag } from '@shared/components/VacationRentalTile/VacationRentalTile.types';

/**
 * Mock vacation rental data for development and testing.
 * @todo [TRAV-2250] Remove once backend API is integrated
 * @todo [TRAV-2250] Move to shared mock data folder
 */
export const mockVacationRentals: ReadonlyArray<VacationRentalAreaDataBackend> = [
  {
    id: '1',
    name: 'South Beach, Miami',
    distanceFromVenue: 1.6,
    walkTimeInMinutes: 30,
    driveTimeInMinutes: 12,
    description: 'South Beach is a vibrant neighborhood known for its beautiful beaches, art deco architecture, and lively nightlife.',
    whyThisZoneIsAGreatPick: 'Great for groups and nightlife\nMost homes can host 4 - 6 people\nGreat for short stays\nHigh demand in peak seasons',
    proposedNoteFromHostToGuest: 'Welcome to South Beach! Enjoy the beautiful beaches and vibrant nightlife.',
    bestForTags: ['families', 'walkable' as VacationRentalTag],
    watchOuts: 'Can be crowded during peak season. Street parking is limited.',
    bounds: {
      ne: { lat: 25.7907, lng: -80.13 },
      sw: { lat: 25.7617, lng: -80.1397 },
    },
    zoneType: 'condo',
    address: 'South Beach, Miami Beach, FL 33139',
    center: { lat: 25.7762, lng: -80.1349 },
    photoUrl: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800',
    distance: {
      __typename: 'TravelDistancesBetweenPointsResponse',
      commonDistance: [
        {
          __typename: 'TravelDistanceBetweenPoints',
          type: DistancesBetweenPointsType.WALKING_DISTANCE,
          km: 2.57,
          mi: 1.6,
          durationMinutes: 30,
        },
        {
          __typename: 'TravelDistanceBetweenPoints',
          type: DistancesBetweenPointsType.DRIVING_DISTANCE,
          km: 2.57,
          mi: 1.6,
          durationMinutes: 12,
        },
        {
          __typename: 'TravelDistanceBetweenPoints',
          type: DistancesBetweenPointsType.GEO_DISTANCE,
          km: 2.57,
          mi: 1.6,
          durationMinutes: 12,
        },
      ],
    },
  },
  {
    id: '2',
    name: 'Wynwood, Miami',
    distanceFromVenue: 2.3,
    walkTimeInMinutes: 45,
    driveTimeInMinutes: 15,
    description: 'Wynwood is an artistic neighborhood famous for its colorful street art, trendy galleries, and hip restaurants.',
    whyThisZoneIsAGreatPick: 'Perfect for art lovers and couples\nWalking distance to galleries and restaurants\nUnique urban vibe\nGreat for Instagram photos',
    proposedNoteFromHostToGuest: 'Explore the famous Wynwood Walls and enjoy the local art scene!',
    bestForTags: ['couples', 'art_lovers' as VacationRentalTag],
    watchOuts: 'Limited beach access. Best to have a car for getting around Miami.',
    bounds: {
      ne: { lat: 25.8103, lng: -80.1918 },
      sw: { lat: 25.794, lng: -80.2015 },
    },
    zoneType: 'house',
    address: 'Wynwood, Miami, FL 33127',
    center: { lat: 25.8022, lng: -80.1967 },
    photoUrl: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800',
    distance: {
      __typename: 'TravelDistancesBetweenPointsResponse',
      commonDistance: [
        {
          __typename: 'TravelDistanceBetweenPoints',
          type: DistancesBetweenPointsType.WALKING_DISTANCE,
          km: 2.57,
          mi: 1.6,
          durationMinutes: 30,
        },
        {
          __typename: 'TravelDistanceBetweenPoints',
          type: DistancesBetweenPointsType.DRIVING_DISTANCE,
          km: 2.57,
          mi: 1.6,
          durationMinutes: 12,
        },
        {
          __typename: 'TravelDistanceBetweenPoints',
          type: DistancesBetweenPointsType.GEO_DISTANCE,
          km: 2.57,
          mi: 1.6,
          durationMinutes: 12,
        },
      ],
    },
  },
];
